import type * as signalR from "@microsoft/signalr";
import {MessageStatus, MessageType, type NotifyPortalMessage} from "@/models/signalr/notify-portal";
import {useMessageHandler} from "@/helpers/error/useMessageHandler";
import {trajectoryOptimizationPageReload} from "@/stores/signalr/notifications/trajectory-optimization-handler";
import {useNavigationStore} from "@/stores/navigation-store";
import {
    organizationProvisionPageReload,
    refreshOrganizations
} from "@/stores/signalr/notifications/organization-provision-handler";

export const initializeSignalrConnection = (signalRConnection: signalR.HubConnection) => {
    const messageHandler = useMessageHandler();
    const navigationStore = useNavigationStore();

    signalRConnection.on("notification", async (notification: NotifyPortalMessage) => {
        messageHandler.notification.destroyAll();

        switch (notification.messageType) {
            case MessageType.TRAJECTORY_OPTIMIZATION_FAILED:
                showNotification(notification, ["{TRANSPORTREFERENCE}", notification.customData ?? ""]);
                trajectoryOptimizationPageReload(navigationStore.routeName);
                break;
            case MessageType.TRAJECTORY_OPTIMIZATION_COMPLETED:
                showNotification(notification, ["{TRANSPORTREFERENCE}", notification.customData ?? ""]);
                trajectoryOptimizationPageReload(navigationStore.routeName);
                break;
            case MessageType.ORGANIZATION_PROVISIONING_COMPLETED:
            case MessageType.ORGANIZATION_PROVISIONING_FAILED:
                showNotification(notification);
                organizationProvisionPageReload(navigationStore.routeName);
                await refreshOrganizations()
                break;
            default:
                showNotification(notification);
                break;
        }
    })

}
export const showNotification = (notification: NotifyPortalMessage, descriptionDataReplacement: [string, string] = ["", ""]) => {
    const messageHandler = useMessageHandler();
    messageHandler.showNotification(
        `notifications.${MessageType[notification.messageType]}.title`,
        `notifications.${MessageType[notification.messageType]}.description`,
        `${MessageStatus[notification.messageStatus]}`,
        () => {
        }, descriptionDataReplacement);
}
